export default {
  default: () => import("/var/jenkins_home/workspace/picmastudio-web-2/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/var/jenkins_home/workspace/picmastudio-web-2/layouts/empty.vue").then(m => m.default || m),
  enhance: () => import("/var/jenkins_home/workspace/picmastudio-web-2/layouts/enhance.vue").then(m => m.default || m),
  logo: () => import("/var/jenkins_home/workspace/picmastudio-web-2/layouts/logo.vue").then(m => m.default || m),
  mobile: () => import("/var/jenkins_home/workspace/picmastudio-web-2/layouts/mobile.vue").then(m => m.default || m)
}